import * as React from 'react';
import * as cx from 'classnames';
import { DataSignal } from 's-js';
import { SuperCriticalComponent } from 'lib/supercritical';

let idGen = 0;

export interface ToggleButtonProps {
    checked : DataSignal<boolean>;
    onLabel : string;
    offLabel : string;
    className? : string;
    selectedLabelClassName? : string;
    disabled? : boolean;
}

export class ToggleButton extends SuperCriticalComponent<ToggleButtonProps> {
    private readonly inputId = '__toggle_button_' + idGen++;
    
    srender({ checked, onLabel, offLabel, className, selectedLabelClassName, disabled } : ToggleButtonProps) {
        return (
            <span className={cx('togglebuttoncomponent', className)}>
                <span className={cx('pc-text-smalllabel', checked() ? selectedLabelClassName : undefined)}>{onLabel}</span>
                {' '}
                <input
                    className="toggle-input"
                    type="checkbox"
                    id={this.inputId}
                    checked={checked()}
                    onChange={e => checked(e.currentTarget.checked)}
                    disabled={disabled}
                />
                <label className="toggle-label" htmlFor={this.inputId}></label>
                {' '}
                <span className={cx('pc-text-smalllabel', !checked() ? selectedLabelClassName : undefined)}>{offLabel}</span>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/togglebutton/view.tsx